

namespace Extension
{
    export class Promise<T> extends globalThis.Promise<T>
    {
    }

    export namespace Promise
    {
        export function isPromise<T>(value: any): value is globalThis.Promise<T>
        {
            return value instanceof Promise;
        }

        export interface Controller<T = any>
        {
            promise: Promise<T>;
            resolve: (result: T) => void;
            reject: (error: any) => void;
        }

        export namespace Controller
        {
            export function create<T = void>(): Controller<T>
            {
                const controller: Partial<Controller<T>> = {};
                controller.promise =
                    new globalThis.Promise<T>(
                        (resolve, reject) =>
                        {
                            controller.resolve = resolve;
                            controller.reject = reject;
                        }
                    );
                return controller as Controller<T>;
            }
        }
    }
}


export type Promise<T> = globalThis.Promise<T>;
export const Promise = Extension.Promise;

export namespace Promise
{
    export type Controller<T = any> = Extension.Promise.Controller<T>;
}


export type PromiseController<T = any> = Extension.Promise.Controller<T>;
export const PromiseController = Extension.Promise.Controller;

